import { useQuery } from '@apollo/client';
import wordsListGraph from '../../services/graphql-queries/words-bank';

export function useWordsList() {
  const { loading, data } = useQuery(wordsListGraph.GET_WORDSLIST, {
    fetchPolicy: 'cache-first'
  });
  return { loading, data };
}
